import React, { useState, useEffect } from "react";
import "./dhenkanal360firstpage.css";


import logo from "../assest/dhenkanal360logo.png";
import cm from "../assest/cm.jpg";
import pd from "../assest/collector.jpg";

import footerstrip from "../assest/footerstrip.jpg";
import "./widget";

import { useTranslation } from "react-i18next";
import Dhealnavbar from "../Navbar/dhealnavbar";

const Dhenkanal360FirstPage = ({ toggleTheme, theme }) => {
  const { t } = useTranslation();
  // const [langMenu, setLangMenu] = useState(false);
  // const [selectedLang, setSelectedLang] = useState("English");



  const [fontSize, setFontSize] = useState(100);

  const increaseFont = () => setFontSize((prev) => Math.min(prev + 10, 150));
  const decreaseFont = () => setFontSize((prev) => Math.max(prev - 10, 70));
  const resetFont = () => setFontSize(100);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    let widgetAdded = false;

    const mountWidget = () => {
      if (window.RAG_WIDGET?.init && !document.getElementById("rag-widget-root")) {
        widgetAdded = true;
        window.RAG_WIDGET.init({ containerId: "rag-widget-mount" });
      }
    };

    mountWidget();
    const retry = setTimeout(mountWidget, 300);

    return () => {
      clearTimeout(retry);
      if (widgetAdded) {
        document.getElementById("rag-widget-root")?.remove();
        document.getElementById("rag-widget-styles")?.remove();
      }
    };
  }, []);
  return (
    <div className={`page-container theme-${theme}`}
      style={{ fontSize: fontSize + "%" }}
    >

      <Dhealnavbar
        toggleTheme={toggleTheme}
        increaseFont={increaseFont}
        decreaseFont={decreaseFont}
        resetFont={resetFont}
        hideMainNavbar={true}
      />

      <div className="header-block">
        <img src={logo} alt="Logo" className="logo" />

        <div>
          <h1 className="odia-title">{t("title_eng")}</h1>

        </div>
      </div>


      <div className="officials-area">

        <div className="off-item">
          <img src={cm} className="off-img" alt="Collector" />
          <p className="off-name">{t("cm_name")}</p>
          <p className="off-pos">{t("cm_pos")}</p>
        </div>

        <div className="off-collitem">
          <img src={pd} className="off-img" alt="Project Director" />
          <p className="off-name">{t("collector_name")}</p>
          <p className="off-pos">{t("collector_pos")}</p>
        </div>

        {/*  <div className="off-item">
          <img src={sp} className="offimg" alt="SP" />
           <p className="off-name">{t("sp_name")}</p>
          <p className="off-pos">{t("sp_pos")}</p>
        </div>*/}


      </div>

      {/* 📝 DESCRIPTION */}
      <p className="desc">{t("feedback_desc")}</p>
      <button
        className="feedback-btn"
        onClick={() => window.open("https://360.dhenkanalservice.in/office/1", "_blank")}
      >
        {t("feedback_btn").split("\n").map((line, index) => (
          <span key={index}>
            {line}
            <br />
          </span>
        ))}
      </button>



      <img src={footerstrip} className="footer-strip" alt="Footer" />

      <div className="footercolpagesss-container">
        <p className="footercolpagesss-text">{t("footerText")}</p>
      </div>

      <div id="rag-widget-mount"></div>
    </div>
  );
};

export default Dhenkanal360FirstPage;
